'use strict';

angular.module('licensure.portal')
    .controller(
        'PublicTimeoutNotifyModalController', function ($scope, logout, stayLoggedIn) {
            $scope.logout = logout;
            $scope.stayLoggedIn = stayLoggedIn;
    })